<template>
    <div class="profile f1">
      <div v-if="$store.getters.emailVerified" class="profile-photo">
        <div class="profile-photo-inner df fdr">
          <div class="profile-photo-image posrel">
            <img
              v-if="$store.getters.userData.companyImage"
              class="profile-image"
              v-bind:src="$store.getters.userData.companyImage"
              alt=""
            >
            <img v-on:click="uploadImage()" src="/images/profile-icons/Edit-Profile-Pen.png" class="posabs edit-profile-icon" alt="">
            <input v-on:change="uploadPhotoContinue()" ref="fileInput" id="fileUploadButton" style="opacity: 0; width: 0; height: 0; position: absolute;" type="file" />
          </div>
          <div class="profile-photo-details df fdc jcc">
            <p class="profile-top-name">
              {{ companyName }}
            </p>
            <p class="profile-top-email">
              {{ companyWebsite }}
            </p>
            <p v-if="fileWrongTypeMessageOn" class="warning-type">Wrong type of file. Please use .jpg or .png.</p>
          </div>
        </div>
      </div>
      <div class="basic-profile">
        <h4 class="mt0">General Info</h4>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc full-width">
            <p>Company Name</p>
            <input v-on:input="changesMade()" v-model="companyName" class="input1" type="text">
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc full-width">
            <p>Company Type</p>
            <select name="" v-model="companyType" class="input1" id="" v-on:change="changesMade()">
              <option v-bind:selected="companyType == 'Digital Agency'" value="Digital Agency">Digital Agency</option>
              <option v-bind:selected="companyType == 'Advertising Agency'" value="Advertising Agency">Advertising Agency</option>
              <option v-bind:selected="companyType == 'Web Developer'" value="Web Developer">Web Developer</option>
              <option v-bind:selected="companyType == 'Creative Agency'" value="Creative Agency">Creative Agency</option>
              <option v-bind:selected="companyType == 'Development Shop'" value="Development Shop">Development Shop</option>
              <option v-bind:selected="companyType == 'Freelance Creative'" value="Freelance Creative">Freelance Creative</option>
              <option v-bind:selected="companyType == 'Freelance Developer'" value="Freelance Developer">Freelance Developer</option>
              <option v-bind:selected="companyType == 'Studio'" value="Studio">Studio</option>
              <option v-bind:selected="companyType == 'Internal Production Team'" value="Internal Production Team">Internal Production Team</option>
            </select>
            <!-- <input v-on:input="changesMade()" v-model="companyType" class="input1" type="text"> -->
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p v-bind:class="{'red-text': !$store.getters.emailVerified}">Website</p>
            <input v-on:input="changesMade()" v-model="companyWebsite" class="input1" type="text">
          </span>
          <span class="input-wrapper df fdc">
            <p>Phone Number</p>
            <input v-on:input="changesMade()" v-mask="'###-###-####'" placeholder="123-456-7890" v-model="phone" class="input1">
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Address</p>
            <input v-on:input="changesMade()" v-model="address" class="input1" type="text">
          </span>
          <span class="input-wrapper df fdc">
            <p>City</p>
            <input v-on:input="changesMade()" v-model="city" class="input1" type="text">
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Country</p>
            <country-select v-on:input="changesMade()" v-model="country" :country="country" topCountry="US" class="input1 region-select" />
          </span>
          <span class="input-wrapper input-wrapper-row input-wrapper-inner df fdr">
            <span class="input-wrapper2 mb0i df fdc">
              <p>Province</p>
              <region-select v-on:input="changesMade()" v-model="province" :country="country" :region="province" class="input1 maxW region-select" />
            </span>
            <span class="input-wrapper2 mb0i df fdc">
              <p :class="invalidPostalCode ? 'error' : ''">{{ invalidPostalCode ? 'Invalid' : '' }} Zip/Postal Code</p>
              <ZipPostalCodeInput
                class="input1"
                v-model="postalCode"
                :onError="invalidCode"
                :country="country"
                v-on:changesMade="changesMade()" />
            </span>
          </span>
        </div>
        <div class="form-row df fdr">
            <span class="input-wrapper df fdc posrel">
              <p>Project Cost</p>
              <input v-on:input="changesMade()" v-digitsonly v-model="companyContingency" size="10" class="input1" type="number">
              <p class="dollar-caption">$</p>
            </span>
            <span class="input-wrapper df fdc posrel">
              <p>Project Rate</p>
              <input v-on:input="changesMade()" v-digitsonly v-model="companyRate" size="10" class="input1" type="number">
              <p class="dollar-caption">$</p>
            </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc w100i">
            <button
              v-on:click="saveCompanyInfo()"
              class="button-form"
              v-bind:class="{ 'button-form-active': companyChangesMade && !invalidPostalCode }"
              :disabled="invalidPostalCode"
            >
              Save Changes
            </button>
          </span>
        </div>
      </div>
  </div>
</template>

<script>
import { JustDigits } from '@/util/filters'
import ZipPostalCodeInput from "@/components/elements/ZipPostalCodeInput";
JustDigits();

export default {
  name: 'CompanyInfoEdit',
  data () {
    return {
      companyChangesMade: false,
      profileChangesMade: false,
      companyName: this.$store.getters.userData.companyName,
      companyWebsite: this.$store.getters.userData.companyWebsite,
      companyType: this.$store.getters.userData.companyType,
      companyRate: this.$store.getters.userData.companyRate,
      companyCost: this.$store.getters.userData.companyCost,
      companyContingency: this.$store.getters.userData.companyContingency,
      companyImage: this.$store.getters.userData.companyImage,

      fileWrongTypeMessageOn: false,
      phone: this.$store.getters.userData.companyPhone,
      address: this.$store.getters.userData.companyAddress,
      city: this.$store.getters.userData.companyCity,
      country: this.$store.getters.userData.companyCountry,
      province: this.$store.getters.userData.companyProvince,
      postalCode: this.$store.getters.userData.companyPostalCode,

      invalidPostalCode: false
    }
  },
  props: [],
  components: {
    ZipPostalCodeInput
  },
  methods: {
    changesMade () {
      this.companyChangesMade = true
    },
    invalidCode(val) {
      this.invalidPostalCode = val;
    },
    cancelEdits () {
      this.$emit('viewProfile')
    },
    saveCompanyInfo () {
      var data = {
        companyID: this.$store.getters.userData.myCompany,
        companyName: this.companyName || '',
        companyWebsite: this.companyWebsite || '',
        companyType: this.companyType || '',
        companyRate: this.companyRate || '',
        companyCost: this.companyCost || '',
        companyContingency: this.companyContingency || '',
        phone: this.phone || '',
        address: this.address || '',
        city: this.city || '',
        country: this.country || '',
        province: this.province || '',
        postalCode: this.postalCode || ''
      }
      if (this.companyChangesMade && !this.invalidPostalCode) {
        this.$store.dispatch('saveCompanyInfo', data).then(() => {
          this.companyChangesMade = false
        })
      }
    },
    uploadImage () {
      this.$refs.fileInput.click()
    },
    uploadPhotoContinue () {
      var inputElement = document.getElementById('fileUploadButton')
      var fileList = inputElement.files
      if (fileList[0]) {
        var data = {
          file: fileList[0],
          companyID: this.$store.getters.userData.myCompany
        }
        this.$store.dispatch('saveCompanyImage', data).then(() => {
          // this.profileChangesMade = false
        })
      }
    },
    removeImage () {
      var data = {
        companyID: this.$store.getters.userData.myCompany
      }
      this.$store.dispatch('deleteCompanyPhoto', data).then(() => {
        this.companyChangesMade = false
      })
    }
  },
  computed: {

  },
  created () {
    document.onkeydown = checkKey;
    var _this = this
    function checkKey(e) {
        e = e || window.event;
        if (e.keyCode == '13') {
            e.preventDefault()
            _this.saveCompanyInfo()
        }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/settings.scss";
h4 {
  /*margin-top: 75px;*/
  font-size: 16px;
  font-family: 'Nexa';
  font-weight: 600;
  margin-bottom: 5px;
}

.error {
  color: red !important;
}

.box {
  padding: 40px;
}


//
// Form Row
//
.form-row {
  width: 100%;

  // Responsive Style
  // @media max-width: 1024px
  @media(max-width: 1024px) {
    // display: block;
    flex-wrap: wrap;
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    display: block;
  }
}


.input-wrapper2{
  width: calc(50% - 10px);
  min-width: 0px;
  flex-direction: column-reverse;
}
.input-wrapper{
  max-width: calc(50% - 40px);
  flex: 1;
  flex-direction: column-reverse;
}
.input-wrapper, .input-wrapper2 {
  margin-bottom: 10px;
  margin-right: 40px;

  & > p {
    color: #000000;
    font-size: 14px;
    letter-spacing: 0.5px;
    line-height: 25px;
    font-size: 12px;
    font-family: 'GG';
    font-weight: 300;
    padding-left: 4px;
    overflow: visible;
    white-space: nowrap;
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    display: block;
    width: auto;
    max-width: unset;
    margin-right: 0;

    // input & select
    input, select {
      display: block;
      width: 100%;
    }
  }
}

.input-wrapper-row {
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
}

.input-wrapper-inner {
  flex: 1px;
  width: 50%;

  & > span {
    margin-right: 0;

    &:first-child {
      margin-right: 30px;
    }
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    flex: none;
    width: auto;

    // span first child
    > span:first-child {margin-right: 0px;}
  }
}


.company-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  object-position: center;
  border-radius: 50%;
}

.button-small {
  margin-left: 40px;

  &:last-child {
    margin-left: 15px;
  }
}

.button-form-cancel {
  background: none;
}


//
// Basic Profile
//
.basic-profile {
  max-width: 570px;
  margin-left: auto;
  margin-right: auto;

  // Responsive Style
  // @media max-width: 1024px
  @media(max-width: 1024px) {
    // width: auto;
    max-width: unset;
  }
}


.edit-profile-icon {
  width: 24px;
  height: 24px;
  background-color: $grey2;
  border-radius: 50%;
  object-fit: none;
  right: 0;
  top: 0;
}
.profile-top-name {
  font-family: 'Nexa';
  font-weight: 600;
  font-size: 24px;
  color: $grey2;
  margin-bottom: 6px;
}
.profile-top-email {
  font-family: 'GG';
  font-weight: 400;
  font-size: 16px;
  color: $grey2;
}
.button-form {
  margin-top: 25px;
}
.change-password {
  margin-top: 50px;
}
.profile-photo-details {
  flex: 1;
  margin-left: 50px;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    margin-left: 20px;
  }
}

.photo-buttons {
  & > button {
    &:first-child {
      margin-right: 40px;
    }
  }
}
.profile-photo-inner {
  /*border-radius: 8px;*/
  /*background-color: white;*/
  /*padding: 50px;*/

  margin-bottom: 15px;
  margin-right: 30px;
  /*box-shadow: 0 1px 4px 0 rgba(0,0,0,0.32);*/

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    margin-right: 0;
  }
}


//
// Dollar Caption
//
.dollar-caption {
  top: 10px;
  left: 3px;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    top: 34px;
  }
}


.input1{
  height: auto;
  padding: 10px;
  padding-left: 16px;
}
.full-width {
  max-width: 100%;
}
</style>
